import { modalEtatServices } from '../../../core/declare-components';
import HuitabHeader from '../../components/common/huitab-header';
import { HuitabPageManager, PageManager } from '../../services/page-manager';
import { PageTypes } from '../../services/settings-loader';
import { TagCommanderManager } from '../../services/tag-commander-manager';
import MicroApp from './micro-app-base';
import { modalDetailleeHPHC, modalMinimalisteHPHC } from '../../../pages/fiche-compteur/main'

/**
 * Microapp mes données énergétiques
 */
export default class CompteursMicroApp extends MicroApp {
  /**
   * Surcharge pour réagir aux messages de la microapp
   */
  childPymEvents = {
    /**
     * Afficher la modal pour montrer la synthese d´état des services souscrits
     */
    consulterEtatServices: (espaces) => {
      modalEtatServices.show(JSON.parse(espaces));
    },
    /**
     * Mise à jour du fil d'Ariane
     * @param {string} msg La clé pour identifier l'action utilisateur
     * Valeurs = [pageCockpit, mesCompteurs, mesSouscriptions, mesAutorisations, donnerAutorisation, gererAutorisation, demandeAutorisation]
     */
    MiseAJourFilAriane: (msg) => {
      switch (msg) {
        case 'mesSouscriptions':
          HuitabHeader.setFilArianeDesktop([
            { label: 'Mes services mesures' },
            { label: 'Mes données énergétiques' },
            { label: 'Mes services mesures' },
          ]);
          HuitabHeader.setFilArianeMobile('Mes services mesures');
          break;

        case 'pageCockpit':
          HuitabHeader.setFilArianeDesktop([
            { label: 'Paramétrer mes services mesures' },
            { label: 'Mes données énergétiques' },
            { label: 'Paramétrer mes services mesures' },
          ]);
          HuitabHeader.setFilArianeMobile('Paramétrer mes services mesures');
          break;

        case 'mesAutorisations':
          HuitabHeader.setFilArianeDesktop([
            { label: 'Mes autorisations mesures' },
            { label: 'Mes données énergétiques' },
            { label: 'Mes autorisations mesures' },
          ]);
          HuitabHeader.setFilArianeMobile('Mes autorisations mesures');
          break;
      }
    },
    ActionMesAutorisations: () => {
      HuitabPageManager.updateUrlWithPath('mes-donnees-energetiques');
      HuitabHeader.setFilArianeDesktop([
        { label: 'Paramétrer mes services mesures' },
        { label: 'Mes données énergétiques' },
        { label: 'Paramétrer mes services mesures' },
      ]);
      HuitabHeader.setFilArianeMobile('Mes autorisations mesures');
    },
    MiseAjourLienHeader: (msg) => {
      switch (msg) {
        case 'pageCockpit':
          HuitabHeader.setLienHeader({
            activeNavLinksDesktop: ['huitab-nav-item-mes-donnees-energetiques', 'huitab-nav-link-acces-mes-compteurs'],
            activeNavLinksMobile: ['huitab-nav-link-acces-mes-compteurs'],
          });
          break;

        case 'mesAutorisations':
          HuitabHeader.setLienHeader({
            activeNavLinksDesktop: [
              'huitab-nav-item-mes-donnees-energetiques',
              'huitab-nav-link-acces-mes-autorisations',
            ],
            activeNavLinksMobile: ['huitab-nav-link-acces-mes-autorisations'],
          });
          break;
      }
    },
    retourAccueil: (msg) => {
      switch (msg) {
        case 'ClicAutorisationVersAccueil':
          TagCommanderManager.tagClick({
            chapitre_1: 'mes_donnees_energetiques',
            chapitre_2: 'gerer_mes_autorisations',
            chapitre_3: 'standard',
            page: 'retour_vers_la_page_d_accueil',
            type: 'action',
          });
          break;
      }
    },
    /**
     * Affiche la page Rechercher compteurs
     */
    afficherCompteurs: () => {
      PageManager.redirectTo(PageTypes.MES_COMPTEURS);
    },
    /**
     * Event pour réagir au clic sur le lien Informations HP/HC avec un compteur >36 kvA
     */
    ouverturePopinDetailleeHPHC: (classesTemporellesPuissanceProgrammeeListeString) => {
      modalDetailleeHPHC.show(classesTemporellesPuissanceProgrammeeListeString);
    },

    /**
     * Event pour réagir au clic sur le lien Informations HP/HC avec un compteur C5 (<36 kvA)
     */
    ouverturePopinMinimalisteHPHC: (classesTemporellesPuissanceProgrammeeListeString) => {
      modalMinimalisteHPHC.show(classesTemporellesPuissanceProgrammeeListeString);
    },
  };

  /**
   * Initialise une nouvelle instance de type {@type CompteursMicroApp}.
   */
  constructor() {
    super();
  }
}
